import reportService from "services/reportService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import moment from "moment";

//ORDER
export const reportOrderStats = createAsyncThunk(
  "report/reportOrderStats",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportOrderStats(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportOrderDailyRevenue = createAsyncThunk(
  "report/reportOrderDailyRevenue",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportOrderDailyRevenue(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportOrderDailyCount = createAsyncThunk(
  "report/reportOrderDailyCount",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportOrderDailyCount(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportOrderRevenueByAirport = createAsyncThunk(
  "report/reportOrderRevenueByAirport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportOrderRevenueByAirport(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportOrderDetailByAirport = createAsyncThunk(
  "report/reportOrderDetailByAirport",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportOrderDetailByAirport(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportOrderExportExcelApi = createAsyncThunk(
  "report/reportOrderExportExcel",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await reportService.reportOrderExportExcel(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY");
      const filename = `Báo cáo đơn hàng và doanh thu_${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//CUSTOMER
export const reportCustomerStats = createAsyncThunk(
  "report/reportCustomerStats",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportCustomerStats(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportCustomerDailyNew = createAsyncThunk(
  "report/reportCustomerDailyNew",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportCustomerDailyNew(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportCustomerRetention = createAsyncThunk(
  "report/reportCustomerRetention",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportCustomerRetention(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportCustomerTopSpending = createAsyncThunk(
  "report/reportCustomerTopSpending",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportCustomerTopSpending(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportCustomerExportExcelApi = createAsyncThunk(
  "report/reportCustomerExportExcel",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await reportService.reportCustomerExportExcel(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY");
      const filename = `Báo cáo khách hàng_${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//DRIVER VEHICLE
export const reportDriverVehicleStats = createAsyncThunk(
  "report/reportDriverVehicleStats",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDriverVehicleStats(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDriverVehicleTopDrivers = createAsyncThunk(
  "report/reportDriverVehicleTopDrivers",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDriverVehicleTopDrivers(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDriverVehicleTopVehicles = createAsyncThunk(
  "report/reportDriverVehicleTopVehicles",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDriverVehicleTopVehicles(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDriverVehicleRanking = createAsyncThunk(
  "report/reportDriverVehicleRanking",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDriverVehicleRanking(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDriverVehicleExportExcelApi = createAsyncThunk(
  "report/reportDriverVehicleExportExcel",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await reportService.reportDriverVehicleExportExcel(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY");
      const filename = `Báo cáo xe và tài xế_${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//VEHICLE EXPENSE
export const reportVehicleExpenseSummary = createAsyncThunk(
  "report/reportVehicleExpenseSummary",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportVehicleExpenseSummary(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportVehicleExpensePieChart = createAsyncThunk(
  "report/reportVehicleExpensePieChart",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportVehicleExpensePieChart(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportVehicleExpenseLineChart = createAsyncThunk(
  "report/reportVehicleExpenseLineChart",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportVehicleExpenseLineChart(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportVehicleExpenseTable = createAsyncThunk(
  "report/reportVehicleExpenseTable",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportVehicleExpenseTable(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportVehicleExportExcelApi = createAsyncThunk(
  "report/reportVehicleExportExcel",
  async (data, { rejectWithValue }) => {
    try {
      const blob = await reportService.reportVehicleExportExcel(data);
      const url = window.URL.createObjectURL(blob);

      const exportTime = moment().format("DDMMYYYY");
      const filename = `Báo cáo chi phí theo xe_${exportTime}.xlsx`;

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;

      document.body.appendChild(link);
      link.click();

      link.remove();
      window.URL.revokeObjectURL(url);

      return true;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

//DASHBOARD
export const reportDashboardStats = createAsyncThunk(
  "report/reportDashboardStats",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDashboardStats(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDashboardUnassignedTrips = createAsyncThunk(
  "report/reportDashboardUnassignedTrips",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDashboardUnassignedTrips(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDashboardUpcomingTrips = createAsyncThunk(
  "report/reportDashboardUpcomingTrips",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDashboardUpcomingTrips(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDashboardDriverStatus = createAsyncThunk(
  "report/reportDashboardDriverStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDashboardDriverStatus(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const reportDashboardActiveTrips = createAsyncThunk(
  "report/reportDashboardActiveTrips",
  async (data, { rejectWithValue }) => {
    try {
      const response = await reportService.reportDashboardActiveTrips(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,

  orderStats: {},
  orderDailyRevenue: [],
  orderDailyCount: [],
  orderRevenueByAirport: [],
  orderDetailByAirport: [],

  customerStats: {},
  customerDailyNew: [],
  customerRetention: {},
  customerTopSpending: [],

  driverVehicleStats: {},
  driverVehicleTopDrivers: [],
  driverVehicleTopVehicles: [],
  driverVehicleRanking: [],

  vehicleExpenseSummary: {},
  vehicleExpensePieChart: [],
  vehicleExpenseLineChart: [],
  vehicleExpenseTable: [],

  dashboardStats: [],
  dashboardUnassignedTrips: [],
  dashboardUpcomingTrips: [],
  dashboardDriverStatus: [],
  dashboardActiveTrips: [],
};

const reportSlice = createSlice({
  name: "report",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
  },
  extraReducers: (builder) => {
    builder
      //ORDER
      .addCase(reportOrderStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportOrderStats.fulfilled, (state, action) => {
        state.loading = false;
        state.orderStats = action.payload;
      })
      .addCase(reportOrderStats.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportOrderDailyRevenue.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportOrderDailyRevenue.fulfilled, (state, action) => {
        state.loading = false;
        state.orderDailyRevenue = action.payload;
      })
      .addCase(reportOrderDailyRevenue.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportOrderDailyCount.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportOrderDailyCount.fulfilled, (state, action) => {
        state.loading = false;
        state.orderDailyCount = action.payload;
      })
      .addCase(reportOrderDailyCount.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportOrderRevenueByAirport.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportOrderRevenueByAirport.fulfilled, (state, action) => {
        state.loading = false;
        state.orderRevenueByAirport = action.payload;
      })
      .addCase(reportOrderRevenueByAirport.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportOrderDetailByAirport.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportOrderDetailByAirport.fulfilled, (state, action) => {
        state.loading = false;
        state.orderDetailByAirport = action.payload;
      })
      .addCase(reportOrderDetailByAirport.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportOrderExportExcelApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportOrderExportExcelApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(reportOrderExportExcelApi.rejected, (state, action) => {
        state.loading = false;
      })

      //CUSTOMER
      .addCase(reportCustomerStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportCustomerStats.fulfilled, (state, action) => {
        state.loading = false;
        state.customerStats = action.payload;
      })
      .addCase(reportCustomerStats.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportCustomerDailyNew.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportCustomerDailyNew.fulfilled, (state, action) => {
        state.loading = false;
        state.customerDailyNew = action.payload;
      })
      .addCase(reportCustomerDailyNew.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportCustomerRetention.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportCustomerRetention.fulfilled, (state, action) => {
        state.loading = false;
        state.customerRetention = action.payload;
      })
      .addCase(reportCustomerRetention.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportCustomerTopSpending.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportCustomerTopSpending.fulfilled, (state, action) => {
        state.loading = false;
        state.customerTopSpending = action.payload;
      })
      .addCase(reportCustomerTopSpending.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportCustomerExportExcelApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportCustomerExportExcelApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(reportCustomerExportExcelApi.rejected, (state, action) => {
        state.loading = false;
      })

      //DRIVER VEHICLE
      .addCase(reportDriverVehicleStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDriverVehicleStats.fulfilled, (state, action) => {
        state.loading = false;
        state.driverVehicleStats = action.payload;
      })
      .addCase(reportDriverVehicleStats.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDriverVehicleTopDrivers.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDriverVehicleTopDrivers.fulfilled, (state, action) => {
        state.loading = false;
        state.driverVehicleTopDrivers = action.payload;
      })
      .addCase(reportDriverVehicleTopDrivers.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDriverVehicleTopVehicles.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDriverVehicleTopVehicles.fulfilled, (state, action) => {
        state.loading = false;
        state.driverVehicleTopVehicles = action.payload;
      })
      .addCase(reportDriverVehicleTopVehicles.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDriverVehicleRanking.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDriverVehicleRanking.fulfilled, (state, action) => {
        state.loading = false;
        state.driverVehicleRanking = action.payload;
      })
      .addCase(reportDriverVehicleRanking.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDriverVehicleExportExcelApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDriverVehicleExportExcelApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(reportDriverVehicleExportExcelApi.rejected, (state, action) => {
        state.loading = false;
      })

      //VEHICLE EXPENSE
      .addCase(reportVehicleExpenseSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportVehicleExpenseSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpenseSummary = action.payload;
      })
      .addCase(reportVehicleExpenseSummary.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportVehicleExpensePieChart.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportVehicleExpensePieChart.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpensePieChart = action.payload;
      })
      .addCase(reportVehicleExpensePieChart.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportVehicleExpenseLineChart.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportVehicleExpenseLineChart.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpenseLineChart = action.payload;
      })
      .addCase(reportVehicleExpenseLineChart.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportVehicleExpenseTable.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportVehicleExpenseTable.fulfilled, (state, action) => {
        state.loading = false;
        state.vehicleExpenseTable = action.payload;
      })
      .addCase(reportVehicleExpenseTable.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportVehicleExportExcelApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportVehicleExportExcelApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(reportVehicleExportExcelApi.rejected, (state, action) => {
        state.loading = false;
      })

      //DASHBOARD
      .addCase(reportDashboardStats.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDashboardStats.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardStats = action.payload;
      })
      .addCase(reportDashboardStats.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDashboardUnassignedTrips.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDashboardUnassignedTrips.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardUnassignedTrips = action.payload;
      })
      .addCase(reportDashboardUnassignedTrips.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDashboardUpcomingTrips.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDashboardUpcomingTrips.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardUpcomingTrips = action.payload;
      })
      .addCase(reportDashboardUpcomingTrips.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDashboardDriverStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDashboardDriverStatus.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardDriverStatus = action.payload;
      })
      .addCase(reportDashboardDriverStatus.rejected, (state, action) => {
        state.loading = false;
      })

      .addCase(reportDashboardActiveTrips.pending, (state) => {
        state.loading = true;
      })
      .addCase(reportDashboardActiveTrips.fulfilled, (state, action) => {
        state.loading = false;
        state.dashboardActiveTrips = action.payload;
      })
      .addCase(reportDashboardActiveTrips.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading } = reportSlice.actions;

export default reportSlice.reducer;